// Require

const { id, log } = require("../std/index")


//
// Invisible Checkbox
//
// When a button stands in for a checkbox, and the checkbox is hidden for
// aesthetic reasons
//

module.exports = class InvisibleCheckboxWidget {
  constructor($host, config) {
    this.dom = {
      button: $('[data-checkbox-trigger]', $host),
      checkbox: $('[data-checkbox-value]', $host)
    };

    this.callbacks = {
      checked: id
    };

    // Listeners
    this.dom.button.on('click', this.toggleCheckbox.bind(this));
  }

  toggleCheckbox() {
    this.dom.checkbox.prop('checked', !this.dom.checkbox.prop('checked'));

    if (this.dom.checkbox.prop('checked')) {
      this.callbacks.checked();
    }
  }

  onChecked(λ) {
    this.callbacks.checked = λ;
  }
};
